<template>
    <div id="about_wrapper">
        <section id="about" style="overflow-x: hidden!important">
            <b-container fluid class="stipple-bg">
                <b-container class="header d-md-flex flex-column justify-content-center">
                    <b-row>
                        <b-col md="7" class="pr-md-0">
                            <img src="/img/this-is-1063.svg" alt="This is 1063" class="w-100 d-block h-auto fade-in-up-element" width="650" height="412">
                        </b-col>
                        <b-col md="5" class="d-flex flex-column justify-content-end">
                            <p class="gotham-book mb-0 mt-md-0 mt-5 fade-in-up-element px-2" style="line-height: 150%">
                                <span class="gotham-bold">We're 1063 in the streets</span>, and Guidelines in the (copy) sheets. A boutique full-service marketing agency creating powerful brand identities that truly drive success. Our close-knit team of designers, writers, web developers, social media experts, account managers, interior designers, and creative directors have made us a driving force in Canadian advertising for over 40 years.
                            </p>
                        </b-col>
                    </b-row>
                </b-container>
            </b-container>
            
            <!--  -->
            <section class="stipple-bg">
                <WhatWeDo class="d-xl-none d-block"/>
                <WhatWeDoScrollPin class="d-xl-block d-none"/>
            </section>
            <!--  -->
            <section id="where-we-do-it" class="stipple-bg">
                <div class="pt-70">
                    <b-container>
                        <p class="gotham-book">WHERE WE DO IT/</p>
                        <WhereWeDoIt />
                        <b-row class="mt-5">
                            <b-col cols="6" class="d-md-flex flex-column pr-md-5">
                                <div class="pl-md-5 fade-in-up-element overflow-hidden d-md-block d-none">
                                    <img src="/img/about/about-front-foyer.jpg" alt="Front Foyer" class="w-100 d-block plax-img" data-lag="0.2">
                                </div>

                                <div class="pl-md-5 fade-in-up-element overflow-hidden d-md-none d-block">
                                    <img src="/img/about/about-front-foyer.jpg" alt="Front Foyer" class="w-100 d-block">
                                </div>
                            </b-col>
                            <b-col cols="5" class="d-md-flex flex-column pl-md-4">
                                <div class="max-w-400">
                                    <nuxt-img 
                                        loading="lazy" 
                                        provider="static" 
                                        format="webp"
                                        src="/img/quotes-left.png" 
                                        alt="Quotations"
                                        class="d-block max-w-40"
                                        width="40"
                                        height="31"
                                        sizes="lg:41px"
                                    />
                                    <div class="fade-in-up-element">
                                        <p class="h4 mt-1 gotham-book">
                                            There's a method 
                                            <br>
                                            to our madness. 
                                            <br>
                                            Scout's honour!
                                        </p>
                                    </div>
                                    <div class="">
                                        <nuxt-img 
                                            loading="lazy" 
                                            provider="static" 
                                            format="webp"
                                            src="/img/quotes-right.png" 
                                            alt="Quotations"
                                            class="d-block max-w-40 ml-auto mr-md-5"
                                            width="40"
                                            height="31"
                                            sizes="lg:41px"
                                        />
                                    </div>
                                </div>
                                <div class="mt-4 pr-md-5 fade-in-up-element overflow-hidden">
                                    <img src="/img/about/about-interior-colors.jpg" alt="Front Foyer" class="w-100 d-block plax-img">
                                </div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </section>
            <!--  -->

            <section class="conclusion py-80 stipple-bg">
                <div>
                    <img src="/img/about/culture-header-img.jpg" alt="People brainstorming" class="w-100 d-block">
                </div>

                <div>
                    <div class="ticker-wrap-culture position-relative">
                        <div class="ticker-wrap-culture-text box-a box">
                            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
                            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
                            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
                            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
                            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
                            <div class="ticker-word-left">&nbsp;____<span class="barlow-semibold">VIBES</span></div>
                        </div>
                    </div>
                </div>
                <b-container class="position-relative">
                    <div class="mt-5">
                        <p class="gotham-book h4 fade-in-up-element">
                            We're pretty chill. Which isn't what you'd expect from 40 years of award-winning work. We've got Bar-Cart Fridays, movie night, costume days, Club 1063, and most of all, the best people. It's this beautiful culture we've been nurturing since inception that's made this place so special to us all.
                        </p>
                        <nuxt-link to="/culture" class="ga-btn-black gotham-book mt-3">TAKE ME TO THE CULTURE PAGE</nuxt-link>
                        <div>
                            <nuxt-img loading="lazy" provider="static" format="webp"
                                src="/img/guidelines-circular-stamp-pink.png" 
                                alt="Guidelines 1063" 
                                class="ga-circular-stamp fade-in-up-element"
                                width="280"
                                height="282"
                                sizes="xs:100vw sm:100vw lg:280px"
                            />
                        </div>
                    </div>
                </b-container>
                
            </section>
            <!-- <div class="position-relative">
                <Transition1063/>
            </div> -->
            <AppFooter />
        </section>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default {
    data() {
        return {
            scrollSmoother_about: null,
            textAnimation_about: null,
            fadeInUpElement_about: null,
            tickerVibes: null
        }
    },
    components: {
        WhatWeDo: () => import('@/components/WhatWeDo'),
        WhatWeDoScrollPin: () => import('@/components/WhatWeDoScrollPin'),
        WhereWeDoIt: () => import('@/components/WhereWeDoIt'),
        Transition1063: () => import('@/components/Transition1063'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initScrollSmoother_aboutPage();
            // 
            this.initImgElReveal_aboutPage();

            this.tickerVibes = gsap;

            this.tickerVibes.to('.ticker-wrap-culture-text', {
                x: -500,
                ease: 'Power1.easeInOut',
                scrollTrigger: {
                    trigger: ".ticker-wrap-culture-text",
                    scrub: 1
                }
            })
        }, 500)
    },
    methods: {
        initScrollSmoother_aboutPage() {
            this.scrollSmoother_about = ScrollSmoother.create({
                wrapper: '#about_wrapper',
                content: "#about",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_about.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_aboutPage() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_about = this.fadeInUpElement_about;
                fadeInUpElement_about = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_about.set(container, { autoAlpha: 1 });
                fadeInUpElement_about.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_about.kill();
        }, 500)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

#about {
    // background-image: url('/img/stipple-background.jpg');
    background-position: center;
    background-size: cover;
    width: 100%;
    z-index: 2;

    .header {
        height: 100vh;
        min-height: 800px;

        @media screen and (max-width: 767px) {
            padding: 140px 15px;
            min-height: unset;
            height: auto;
        }
    }

    #where-we-do-it {
        .pink-bg-overlay {
            position: absolute;
            top: 0;
            width: 100%;
            height: 20px;
            background-color: rgba($color: #850147, $alpha: 0.55);
        }
    }

    .ga-circular-stamp {
        position: absolute;
        right: 0;
        bottom: -140px;
        width: 100%;
        max-width: 280px;
        z-index: 1;

        @media screen and (max-width: 767px) {
            display: none;
        }
    }

    .ticker-wrap-culture-text {
        white-space: nowrap;
        color: #000;
    }

    .ticker-word-left {
        left: 0;
        width: auto;
        font-size: 8rem;
        display: inline-block;
    }
}


</style>